export default __webpack_public_path__ + "static/media/Sparsh.96420492.jpeg";